const GA_COOKIE_NAME = '_ga';

// Extracts the GA4 Client ID (CID) from the _ga cookie, e.g. "GA1.1.<cid1>.<cid2>" -> "<cid1>.<cid2>".
export const getGoogleAnalyticsClientId = (): string | null => {
  if (typeof document === 'undefined') return null;

  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${GA_COOKIE_NAME}=([^;]+)`));

  if (!match) {
    return null;
  }

  const parts = decodeURIComponent(match[1]).split('.');

  return parts.length >= 4 ? `${parts[2]}.${parts[3]}` : null;
};
